module.exports = __webpack_public_path__ + "assets/img/5_1153.10cccc6c.jpg";